import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Unsubscriber } from '@core-lib/classes';
import { PageService } from '@core-lib/services/page.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'page-header',
    templateUrl: './page-header.component.html',
    standalone: false
})
export class PageHeaderComponent extends Unsubscriber implements OnInit {
	@Input() pageTitle: string;
	@Input() pageSubTitle: string;
	@Input() pageTitleAffaireName: string;

	@Input() hasBackButton: boolean;

	@Input() backNavigation: Function;

	hasSpecialStyle: boolean = false;
	hasSubSpecialStyle: boolean = false;
	tooltip: string = '';

	constructor(
		private pageService: PageService,
		public location: Location
	) {
		super();
	}

	ngOnInit(): void {
		if (!this.pageTitle) {
			this.pageService.pageTitle$.pipe(takeUntil(this.destroySubscriptions$)).subscribe(title => {
				this.pageTitle = title[0];
				this.hasSpecialStyle = title[1];
			});
		}

		if (!this.pageSubTitle) {
			this.pageService.pageSubTitle$.pipe(takeUntil(this.destroySubscriptions$)).subscribe(subTitle => {
				this.pageSubTitle = subTitle[0];
				this.hasSubSpecialStyle = subTitle[1];
			});
		}
		
		if (!this.pageTitleAffaireName) {
			this.pageService.pageTitleAffaireName$.pipe(takeUntil(this.destroySubscriptions$)).subscribe(affaireName => {
				this.pageTitleAffaireName = this.getaffaireName (affaireName[0],40);
				this.tooltip = affaireName[0];
			});
		}
	}

	private getaffaireName(affaireNameFull: string, maxLength:number):string {
		return affaireNameFull.length > maxLength
			? affaireNameFull.slice(0, maxLength - 3).trimEnd() + '...'
			: affaireNameFull;
	}
}
